// Curated Unsplash images for flooring & interiors
export const heroImages = [
  "https://images.unsplash.com/photo-1628744876525-f2678d8af47f?auto=format&fit=crop&w=1920&q=80",
  "https://images.unsplash.com/photo-1598718544285-7180f670198b?auto=format&fit=crop&w=1920&q=80",
  "https://images.unsplash.com/photo-1599243272864-e9dd455966bd?auto=format&fit=crop&w=1920&q=80",
  "https://images.unsplash.com/photo-1628744876497-eb30460be9f6?auto=format&fit=crop&w=1920&q=80",
];

export const productImages = {
  parquet:  "https://images.unsplash.com/photo-1628744876525-f2678d8af47f?auto=format&fit=crop&w=1400&q=80",
  vinyl:    "https://images.unsplash.com/photo-1493663284031-b7e3aefcae8e?auto=format&fit=crop&w=1400&q=80",
  laminate: "https://images.unsplash.com/photo-1598718544285-7180f670198b?auto=format&fit=crop&w=1400&q=80",
  carpet:   "https://images.unsplash.com/photo-1611048267451-e6ed903d4a38?auto=format&fit=crop&w=1400&q=80",
  design:   "https://images.unsplash.com/photo-1599243272864-e9dd455966bd?auto=format&fit=crop&w=1400&q=80",
};

export const galleryImages = [
  {
    src: "https://images.unsplash.com/photo-1628744876497-eb30460be9f6?auto=format&fit=crop&w=1200&q=80",
    category: "parquet",
    label: "Eiche · Altbau, Mülheim",
  },
  {
    src: "https://images.unsplash.com/photo-1493663284031-b7e3aefcae8e?auto=format&fit=crop&w=1200&q=80",
    category: "vinyl",
    label: "Vinyl · Loft Duisburg",
  },
  {
    src: "https://images.unsplash.com/photo-1505691938895-1758d7feb511?auto=format&fit=crop&w=1200&q=80",
    category: "laminate",
    label: "Laminat · Büro Essen",
  },
  {
    src: "https://images.unsplash.com/photo-1599243272864-e9dd455966bd?auto=format&fit=crop&w=1200&q=80",
    category: "design",
    label: "Designboden · Café Oberhausen",
  },
  {
    src: "https://images.unsplash.com/photo-1567016526105-22da7c13161a?auto=format&fit=crop&w=1200&q=80",
    category: "carpet",
    label: "Wollteppich · Wohnzimmer",
  },
  {
    src: "https://images.unsplash.com/photo-1556909114-f6e7ad7d3136?auto=format&fit=crop&w=1200&q=80",
    category: "parquet",
    label: "Räuchereiche · Neubau",
  },
  {
    src: "https://images.unsplash.com/photo-1615874959474-d609969a20ed?auto=format&fit=crop&w=1200&q=80",
    category: "vinyl",
    label: "Vinyl · Bad",
  },
  {
    src: "https://images.unsplash.com/photo-1493809842364-78817add7ffb?auto=format&fit=crop&w=1200&q=80",
    category: "design",
    label: "Designboden · Showroom",
  },
];
